(ns app.front.dashboard.business
  (:require [app.domain.business.model :as business-model]
            [app.front.dashboard.common :as dashboard-common]
            [core.front.event :refer [<sub]]
            [core.front.href :as href]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::fetch-my-businesses
  (fn [_ _]
    {:dispatch [:comm/command-monitored
                {:command    :business/my-businesses
                 :method     :get
                 :on-success [::fetch-my-businesses.success]}]}))


(rf/reg-event-db ::fetch-my-businesses.success
  (fn [db [_ _ results]] (assoc db ::my-businesses results)))


(rf/reg-sub ::my-businesses :-> ::my-businesses)


(rf/reg-sub ::show-dashlet?
  :<- [::my-businesses]
  :-> util/not-empty?)


(defn- business-link [{:keys [lang]} {:db/keys [id] :as business}]
  [dashboard-common/link-box {:title (business-model/format-name business lang)
                              :href  (href/href :view/business {:business-id id})}])


(defn businesses-dashlet []
  (let [lang       (<sub [:language])
        tr         (<sub [:tr])
        businesses (<sub [::my-businesses])]
    [:section.dashlet
     [:h2 (tr [:business/my-businesses])]
     [dashboard-common/link-box-container
      (for [{:db/keys [id] :as business} businesses]
        ^{:key id} [business-link (util/mmap lang) business])]]))
